import Icon from "~/components/shared/Icon";
import Indicator from "~/components/shared/Indicator";
import { twMerge } from "tailwind-merge";
import { useBuild } from "~/components/build/Show/lib/BuildContext";
import { getAnnotationCounts } from "~/components/build/Show/lib/annotationCounts";
import { useAnnotationsPanel } from "~/components/build/Show/lib/useAnnotationsPanel";

export default function AnnotationsPanelToggle() {
  const { build } = useBuild();
  const totalCount = getAnnotationCounts(build).totalCount;
  const { isOpen, toggle } = useAnnotationsPanel();

  const errorCount =
    (build.annotationCountsByStyle?.error || 0) +
    (build.statistics?.jobAnnotationCountsByStyle?.error || 0);
  const hasErrors = errorCount > 0;

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="AnnotationsPanelToggle"
      aria-pressed={isOpen}
      title={isOpen ? "Close annotations panel" : "Open annotations panel"}
      className={twMerge(
        "relative inline-flex size-7 items-center justify-center rounded-sm bg-white shadow-[inset_0_-1px_0_0_rgba(0,0,0,0.05),0_0_0_1px_rgba(0,0,0,0.08),0_1px_0_0_rgba(0,0,0,0.1)] transition-[background-color,box-shadow,color] duration-100",
        isOpen ? "text-[#334155] hover:bg-white" : "text-purple-600 hover:bg-gray-100",
      )}
    >
      <span className="relative inline-flex items-center">
        <Icon
          icon={isOpen ? "custom/outline/panel-right-close" : "custom/outline/panel-right-open"}
          className="size-[18px]"
        />
        {!isOpen && totalCount > 0 && (
          <Indicator
            animate={false}
            size="sm"
            color={hasErrors ? "red" : "purple"}
            className="absolute right-0 top-0 -translate-y-[calc(50%_-_1px)] translate-x-[calc(50%_-_2px)]"
          />
        )}
      </span>
    </button>
  );
}
